const getClosestFlyoutContainer = (el) => {
    const style = el && window.getComputedStyle(el);
    const position = style?.position;
    const overflow = style?.overflow;
    const isScrollable = overflow?.includes("scroll") || overflow?.includes("auto");
    const isFixed = position === "fixed";
    if (el === document.body || !el)
        return document.body;
    if ((isScrollable &&
        (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth)) ||
        isFixed) {
        return el;
    }
    return getClosestFlyoutContainer(el.parentElement);
};
export default getClosestFlyoutContainer;
